module.exports = __webpack_public_path__ + "img/bibliotheque.9abbee96.jpg";